import { AssetTypes } from "@zapier/utils";
import { trpc } from "../trpc";
import { useMemo } from "react";

export function useCanvasConnectedAssets(canvasId?: string) {
  const {
    data: connectedAssets,
    isLoading: isConnectedAssetsLoading,
    isFetching: isConnectedAssetsFetching,
  } = trpc.canvas.connectedAssets.useQuery(
    { canvasId: canvasId || "" },
    { enabled: !!canvasId },
  );

  const transformedAssets: { id: string; title: string; type: AssetTypes }[] =
    useMemo(() => {
      if (!connectedAssets || !Array.isArray(connectedAssets)) {
        return [];
      }

      // The BFF already flattens the response, so we just need to map it
      return connectedAssets.map((asset: any) => ({
        id: asset.assetId,
        title: asset.name || "Untitled Asset",
        type: asset.assetType as AssetTypes,
      }));
    }, [connectedAssets]);

  const hasNonBlockingConnections = transformedAssets.some(
    (asset) => asset.type !== AssetTypes.Interface,
  );

  const hasBlockingConnections = transformedAssets.some(
    (asset) => asset.type === AssetTypes.Interface,
  );

  return {
    hasNonBlockingConnections,
    hasBlockingConnections,
    transformedAssets,
    isLoading: isConnectedAssetsLoading,
    isFetching: isConnectedAssetsFetching,
  };
}
